// extracted by css-extract-rspack-plugin
export default {"root":"root-Wvass1"};